module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u-Citibank-Scholarships_Banner-fb638006446714a344e86d9e84ee1aa2.jpg";